import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import axios from 'axios';

export const getData = createAsyncThunk('quickNotesPanel/data/getData', async () => {
	const response = await axios.get('/api/quick-notes-panel/data');
	const data = await response.data;

	return data;
});

const dataSlice = createSlice({
	name: 'quickNotesPanel/data',
	initialState: null,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(getData.fulfilled, (state, action) => action.payload);
	}
});

export default dataSlice.reducer;
